import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action
} from "vuex-module-decorators";
import store from "@/general/store";

@Module({
  name: "meta",
  store: store,
  namespaced: true,
  dynamic: true
})
class MetaModule extends VuexModule {
  data: any = [];

  get title() {
    const metaTitle = process.env.VUE_APP_PAGE_TITLE;
    return metaTitle;
  }

  // get description() {
  //   const metaDescription = this.getMetaData("description")
  //     ? this.getMetaData("description")
  //     : "";
  //   return metaDescription;
  // }

  @Mutation
  set(payload: any) {
    this.data = payload;
  }

  // metaデータをAPIで取得したときの処理

  @Action({ rawError: true })
  setMetaDataList(value: any) {
    for (const key in value) {
      const label = key != "imageUrl" ? key : "thumbnail";
      const metaData = value[key];
      this.data.push({ [label]: metaData });
    }
    this.createDocumentMetaData();
  }

  // 特定のメタkeyに対する値を取得
  @Action({ rawError: true })
  getMetaData(key: string) {
    const target: any = this.data.filter((x: any) => {
      const obj = Object.entries(x)[0];
      return obj[0] == key;
    });

    const result = target.length > 0 ? target[0][key] : "";
    return result;
  }

  // document Titleの設定
  // @Action({ rawError: true })
  @Mutation
  async setDocumentTitle(value = "") {
    let metaTitle = value ? value + " | " : "";
    metaTitle += this.title;

    if (!document.title) {
      const titleElement = document.createElement("title");
      document.head.appendChild(titleElement);
    }
    document.title = metaTitle;
  }

  // document Desctiptionの設定
  @Action({ rawError: true })
  setDocumentDesctiption(value = "") {
    const metaDescription: any = value
      ? value
      : process.env.VUE_APP_PAGE_DESCRIPTION;

    if (!document.querySelector('meta[name="description"]')) {
      const descriptionElement = document.createElement("meta");
      descriptionElement.setAttribute("name", "description");
      descriptionElement.setAttribute("content", "");
      document.head.appendChild(descriptionElement);
    }

    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", metaDescription);
  }

  // metaDataを追加する
  @Action({ rawError: true })
  addMetaData(value: string) {
    // オブジェクト形式かどうかをチェック
    // オブジェクト形式ではない場合処理を中止する
    const objectType = Object.prototype.toString;
    if (objectType.call(value) != "[object Object]") return;
    this.data.push(value);
    this.createDocumentMetaData();
  }

  // 既存のmetaDataを修正する
  @Action({ rawError: true })
  modifiedMedaData(key: any, value: any) {
    const modifiedData: any = this.data.map((x: any) => {
      const obj = Object.entries(x)[0];
      const label = obj[0];
      const metaData = obj[0] == key ? value : obj[1];
      return { [label]: metaData };
    });
    this.data = modifiedData;
  }

  // metaDataの動的な作成
  createDocumentMetaData() {
    for (const item of this.data) {
      const obj: any = Object.entries(item)[0];
      const key: any = obj[0];
      const meta: any = obj[1];
      // 既存のmetaは追加しない
      if (document.querySelector(`meta[name="${key}"]`)) continue;
      const metaElement = document.createElement("meta");
      metaElement.setAttribute("name", key);
      metaElement.setAttribute("content", meta);
      document.head.appendChild(metaElement);
    }
  }

  // 動的に追加されたmetaDataを削除する
  @Action({ rawError: true })
  deleteDocumentMetaData() {
    for (const item of this.data) {
      const obj = Object.entries(item)[0];
      const key = obj[0];
      const metaElement = document.querySelector(`meta[name="${key}"]`);
      metaElement?.remove();
    }
    this.data = [];
  }
}

export default getModule(MetaModule);
